import { render, staticRenderFns } from "./title-2.vue?vue&type=template&id=603ee3c3&scoped=true"
import script from "./title-2.vue?vue&type=script&lang=js"
export * from "./title-2.vue?vue&type=script&lang=js"
import style0 from "./title-2.vue?vue&type=style&index=0&id=603ee3c3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "603ee3c3",
  null
  
)

export default component.exports